export interface ITableButton {
    event: string;
    title: string;
}

export interface ITableColumnSettings {
    buttons?: ITableButton[];
    canFilter?: boolean;
    canSort?: boolean;
    columnOrder?: number;
    dataFilter?: string;
    dataType: TableCellDataType;
    filter?: string;
    footerText?: string;
    isVisible?: boolean;
    propertyName?: string;
    title?: string;
    width?: string;
}

export enum RowClass {
    HighlightRed = 'highlight-red',
    RowEven = 'row-even'
}

export type TableCellDataType = 'button' | 'date' | 'html' | 'string' | 'url';

export enum TableCellWrapMode {
    Ellipsis = 'ellipsis',
    HorizontalScroll = 'horizontal-scroll',
    Wrap = 'wrap'
}

export enum TableColumnSortMode {
    Multiple = 'multiple',
    None = 'none',
    Single = 'single'
}
